import { render, staticRenderFns } from "./MainChart.vue?vue&type=template&id=479dd522"
import script from "./MainChart.vue?vue&type=script&lang=js"
export * from "./MainChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports